import { Injectable, signal } from '@angular/core';
import { AppSettingsType, getAppSettings } from '@kspl-franco';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private readonly _appSettings = signal<AppSettingsType | null>(null);
  private loadingPromise: Promise<void> | null = null;

  readonly appSettings = this._appSettings.asReadonly();

  async loadAppSettings(): Promise<void> {
    if (this._appSettings() !== null) {
      return;
    }

    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    this.loadingPromise = this.fetchAppSettings();
    return this.loadingPromise;
  }

  private async fetchAppSettings(): Promise<void> {
    try {
      const response = await getAppSettings();

      if (response.data) {
        this._appSettings.set(response.data.settings);
      }
    } finally {
      this.loadingPromise = null;
    }
  }
}
